/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Document statistics for a company.
 * @export
 * @interface DocumentStatsResponse
 */
export interface DocumentStatsResponse {
    /**
     * 
     * @type {number}
     * @memberof DocumentStatsResponse
     */
    totalDocuments: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentStatsResponse
     */
    pendingDocuments: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentStatsResponse
     */
    parsedDocuments: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentStatsResponse
     */
    failedDocuments: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentStatsResponse
     */
    totalSizeBytes: number;
}

/**
 * Check if a given object implements the DocumentStatsResponse interface.
 */
export function instanceOfDocumentStatsResponse(value: object): value is DocumentStatsResponse {
    if (!('totalDocuments' in value) || value['totalDocuments'] === undefined) return false;
    if (!('pendingDocuments' in value) || value['pendingDocuments'] === undefined) return false;
    if (!('parsedDocuments' in value) || value['parsedDocuments'] === undefined) return false;
    if (!('failedDocuments' in value) || value['failedDocuments'] === undefined) return false;
    if (!('totalSizeBytes' in value) || value['totalSizeBytes'] === undefined) return false;
    return true;
}

export function DocumentStatsResponseFromJSON(json: any): DocumentStatsResponse {
    return DocumentStatsResponseFromJSONTyped(json, false);
}

export function DocumentStatsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentStatsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalDocuments': json['totalDocuments'],
        'pendingDocuments': json['pendingDocuments'],
        'parsedDocuments': json['parsedDocuments'],
        'failedDocuments': json['failedDocuments'],
        'totalSizeBytes': json['totalSizeBytes'],
    };
}

export function DocumentStatsResponseToJSON(json: any): DocumentStatsResponse {
    return DocumentStatsResponseToJSONTyped(json, false);
}

export function DocumentStatsResponseToJSONTyped(value?: DocumentStatsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalDocuments': value['totalDocuments'],
        'pendingDocuments': value['pendingDocuments'],
        'parsedDocuments': value['parsedDocuments'],
        'failedDocuments': value['failedDocuments'],
        'totalSizeBytes': value['totalSizeBytes'],
    };
}

